export default "__VITE_ASSET__vNF9Jjwt__"